export default class Authentication {
	authenticationPaths = null;
	siteId = null;

	constructor(authenticationPaths, siteId) {
		this.authenticationPaths = authenticationPaths;
		this.siteId = siteId;
	}


	 // Function to find access by path
	 getRouteAccess(searchRoute) {
		const routeToRegex = (route) => {
			//create a regex, that matches all cases, * wildcards and optional trailing slash
			return new RegExp(route
				.trimEnd('/')
				.replaceAll('/', '\\/')
				.replaceAll('*', '.+')
				+ '/?'
			, "i");
		}

		let route = this.authenticationPaths.restrictedRoutes.find(route => 
			routeToRegex(route.path).test(searchRoute)
		);

		return route ? route.access : "public";
	};


	//determine if the given route is the logout route
	isLogoutRoute(searchRoute) {
		return this.authenticationPaths.logoutPath == this.normalizePath(searchRoute);
	}

	//convert to lowercase and ensure trailing slash
	normalizePath(path) {
		const normalizedPath = path.toLowerCase(); //lowercase
		return normalizedPath.endsWith('/') ? normalizedPath : `${normalizedPath}/`; //ensure trailing slash
	}

	//gets logged in user, if any
	async isloggedin() {
		return await $fetch('/api/login/isloggedin', {
			method: 'GET',
			headers: useRequestHeaders(['cookie']),
		})
			.then((response) => {
				//console.log('response', response);
				return {
					loggedIn: !(response?.isLoggedOut ?? true),
					member: response
				}
			})
			.catch(() => {
				return {
					loggedIn: false,
					member: null
				}
			});
	}

	//logout
	async logout() {
		return await $fetch('/api/login/logout?siteId=' + this.siteId, {
			method: 'GET',
		})
		.then((response) => {
			//console.log('logout response', response);
			return response;
		})
	}


	async middlewareHandler(to, mainStore) {
		//redirect to logout
		if (this.isLogoutRoute(to.path))
		{
			var loginStatus = await this.logout();
			mainStore.setLoggedIn(false);

			//console.log('logoutStatus', loginStatus);

			if (loginStatus.logoutRedirect != null)
			{
				//membercare logout redirect
				return loginStatus.logoutRedirect;
			}

			return mainStore.site.url;
		}
	
		//check login
		let login = await this.isloggedin();
		mainStore.setLoggedIn(login.loggedIn, login.member);

		//notification if no subscription
		if (login.loggedIn && !login.member.subscriptionValid && this.siteId == 'mba')
		{
			mainStore.setNotificationMessage('Køb abonnement for at få fuld adgang til MBA. Klik her.', this.authenticationPaths.paymentPath);
		}

		//get acces to current route
		var routeAccess = this.getRouteAccess(to.path);
	
		//redirect to login
		if ((routeAccess == 'login' || routeAccess == 'subscription')  && !login.loggedIn) {
			return this.authenticationPaths.loginPath + "?return=" + encodeURIComponent(to.path);
		}
	
		//redirect to payment
		if (routeAccess == 'subscription' && login.loggedIn && !login.member.subscriptionValid) {

			return this.authenticationPaths.paymentPath + "?return=" + encodeURIComponent(to.path);
		}		

		return null;
	}

}